function setExidTm(id, tm) {
  window.exid = id;
  window.tm = tm;
}

function getExidTm() {
  return { exid: window.exid, tm: window.tm };
}

function setCurIdIcn(id, icn) {
  window.currentPlayingBtn = id;
  window.currentPlayIcon = icn;
}

/*
 * https://stackoverflow.com/questions/57776001/how-to-detect-ipad-pro-as-ipad-using-javascript
 * The detectMob() works for everything but iPads. From a certain version of iPadOS
 * Apple said you get desktop class browsing on iPads. From then on navigator.userAgent
 * returns Macintosh as the device. So my little preload routine for autio did not work
 * only on iPad. Hence this extra workaround of using maxTouchPoints to detect iPad.
 */
/*
function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

function isIOS() {
  if (/iPad|iPhone|iPod/.test(navigator.platform)) {
    return true;
  } else {
    return (
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2 &&
      /MacIntel/.test(navigator.platform)
    );
  }
}

function isIpadOS() {
  return (
    navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform)
  );
}
*/

// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
// function mobCheck() {
//   let check = false;
//   (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
//   return check;
// };

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function toggleSearchAudio(title, src, id, tm) {
  var ap = document.getElementById("aplayer");
  var aps = document.getElementById("apsrc");
  //var apt = document.getElementById("aptitle");
  var e = document.getElementById(`srch-res-btn-${id}`);
  var eicn = document.getElementById(`srch-res-icn-${id}`);

  window.noAudioLoaded = false;
  setCurIdIcn(`srch-res-btn-${id}`, `srch-res-icn-${id}`);

  var { exid, extm } = getExidTm();
  if (aps.src !== src) {
    aps.src = src;
    //apt.innerHTML = et.innerText.substr(0, 20).concat("...");
    //apt.innerHTML = title.substr(0, 20).concat("...");
    /*console.log(aps.src);*/
    ap.load();

    /*
     * Workaround for mobile browsers. They don't preload audio until some button on
     * the screen is pressed. Because of this side-effect, if clicking the play button
     * on a transcript line is the very first action on a page, the audio will always
     * play from time=0. This is because the audio is not preloaded and not seekable.
     * so `jumpAudio(t)` will just start playing from t=0 even if t=120 or something
     * else. This is confirmed by printing the `readyState` property of the audio
     * element. You'll see this is = 4 on the desktop browser and = 1 on mobile.
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/readyState
     *
     * As a workaround what I'm doing is if window.preload = 0, then this is the first
     * interaction on the screen. So do a very quick audio.play() followed by .pause()
     * this will force the page to preload the audio it will then let me seek to the
     * correct time. This is an old technique called audio sprites
     * https://pupunzi.open-lab.com/2013/03/13/making-html5-audio-actually-work-on-mobile/
     */
    // detect mobile browsers and do this only for them
    // You can see the play button in the search results flicker for a second
    // I'm just trying to preload audio.
    //var mc = detectMob() || isIOS() || isIpadOS();
    //if (mc) {
    //console.log('Ok');
    await ap.play();
    //console.log('Ok2');
    ap.pause();
    //console.log('Ok3');
    await sleep(100);
    //console.log('Ok4');
    //}
  }

  if (extm !== tm) {
    ap.currentTime = tm;
  }

  /*console.log(ap);*/
  if (id !== exid) {
    ap.play();
    window.isPlaying = true;
    // e.classList.remove("is-info", "is-warning");
    // e.classList.add("is-danger");
    // eicn.classList.remove("fa-play");
    // eicn.classList.add("fa-pause");
    // console.log("Helloo");
  } else {
    if (ap.paused) {
      // console.log("paused", e.id);

      ap.play();
      window.isPlaying = true;
      // e.classList.remove("is-info", "is-warning");
      // e.classList.add("is-danger");
      // eicn.classList.remove("fa-play");
      // eicn.classList.add("fa-pause");
    } else {
      // console.log("paused", e.id);
      ap.pause();
      window.isPlaying = false;
      // e.classList.remove("is-danger", "is-info");
      // e.classList.add("is-warning");
      // eicn.classList.remove("fa-pause");
      // eicn.classList.add("fa-play");
    }
  }

  if (exid && exid !== id) {
    //console.log(exid);
    var ex = document.getElementById(`srch-res-btn-${exid}`);
    //console.log("ex", ex);
    var exicn = document.getElementById(`srch-res-icn-${exid}`);
    if (ex) {
      ex.classList.remove("is-danger");
      ex.classList.add("is-warning");
    }
    if (exicn) {
      exicn.classList.remove("fa-pause");
      exicn.classList.add("fa-play");
    }
    //console.log("Helloo2");
  }
  //console.log(getExidTm());
  setExidTm(id, tm);
  //console.log(getExidTm());
}
